// Shared vocabulary for the ACPP Module 6 approvals dashboard.
// Stage keys are the backend's `workflow_stage` values; `changes_requested` is
// the backend's derived `display_status` (a draft that was just sent back).

export const STAGE_META = {
  teacher_draft: {
    label: "Draft",
    pill: "bg-slate-100 text-slate-700 border-slate-200",
    dot: "bg-slate-400",
  },
  hod_review: {
    label: "Awaiting HOD",
    pill: "bg-amber-50 text-amber-800 border-amber-200",
    dot: "bg-amber-500",
  },
  admin_review: {
    label: "Awaiting Admin",
    pill: "bg-blue-50 text-blue-800 border-blue-200",
    dot: "bg-blue-500",
  },
  approved: {
    label: "Approved",
    pill: "bg-emerald-50 text-emerald-800 border-emerald-200",
    dot: "bg-emerald-500",
  },
  changes_requested: {
    label: "Changes requested",
    pill: "bg-rose-50 text-rose-800 border-rose-200",
    dot: "bg-rose-500",
  },
};

export function metaFor(displayStatus, stage) {
  return STAGE_META[displayStatus] || STAGE_META[stage] || STAGE_META.teacher_draft;
}

// Filter pills, in the order reviewers think about them.
export const FILTERS = [
  { key: "pending", label: "Needs my review", countKey: "pending" },
  { key: "hod_review", label: "Awaiting HOD", countKey: "hod_review" },
  { key: "admin_review", label: "Awaiting Admin", countKey: "admin_review" },
  { key: "changes_requested", label: "Changes requested", countKey: "changes_requested" },
  { key: "approved", label: "Approved", countKey: "approved" },
  { key: "teacher_draft", label: "Drafts", countKey: "teacher_draft" },
  { key: "all", label: "All", countKey: "all" },
];

const ROLE_LABEL = { teacher: "Teacher", hod: "HOD", admin: "Admin", system: "System", system_edit: "System" };
export const roleLabel = (role) => ROLE_LABEL[role] || role || "";

export function describeHistoryEntry(entry) {
  const role = entry.role;
  switch (entry.action) {
    case "submit":
      return "Submitted for HOD review";
    case "recall":
      return "Recalled by the teacher";
    case "approve":
      return role === "admin" ? "Approved by admin" : "Approved by HOD, sent to admin";
    case "request_changes":
      return entry.from === "admin_review" && role === "admin"
        ? "Admin sent back to HOD"
        : "Changes requested";
    case "request_changes_teacher":
      return "Admin sent back to teacher";
    case "hod_override":
      return "Admin skipped the HOD approval";
    case "material_edit":
      return "Edited after approval; re-approval required";
    case "content_edit":
      return "Content edited by a reviewer";
    case "generation_warning":
      return "Downstream outline warning";
    default:
      return entry.action || "Updated";
  }
}

export function formatWhen(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString(undefined, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const mins = Math.round((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 48) return `${hrs}h ago`;
  return `${Math.round(hrs / 24)}d ago`;
}

export const classLabel = (row) => `${row.grade || "?"}-${row.section || "?"}`;
